import state from './state';
import mutations from './mutations';
import { Module } from 'vuex';
import { RootStateShape, MessagesStateShape } from 'store';

export default {
	namespaced: true,
	state,
	mutations
} as Module<MessagesStateShape, RootStateShape>;
